import { useState, useEffect } from "react";
import { Menu, X, Phone, ChevronRight } from "lucide-react";
import { LOGO_URL, NAV_LINKS, COMPANY } from "../data/mock";
import { Button } from "./ui/button";

export const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (href) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <header className={`sticky top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-xl shadow-lg shadow-navy-950/5 border-b border-slate-200/60' : 'bg-white/90 backdrop-blur-md border-b border-slate-100/50'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-[72px]">
          {/* Logo */}
          <a href="#" className="flex items-center gap-3 shrink-0" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img
              src={LOGO_URL}
              alt="Hevi Haul Inc."
              className="h-10 lg:h-[48px] w-auto object-contain rounded-lg"
              style={{ background: 'transparent' }}
            />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-1">
            {NAV_LINKS.map((link) => (
              <button
                key={link.label}
                onClick={() => scrollTo(link.href)}
                className="text-slate-500 hover:text-navy-800 font-medium text-[13px] tracking-wide transition-colors duration-200 relative group px-4 py-2 rounded-lg hover:bg-navy-50/50"
              >
                {link.label}
                <span className="absolute bottom-0.5 left-4 right-4 h-[2px] bg-hevi-blue rounded-full scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />
              </button>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center gap-4">
            <a href={`tel:${COMPANY.phone}`} className="flex items-center gap-2 text-sm text-slate-500 hover:text-navy-800 font-medium transition-colors duration-200">
              <div className="w-8 h-8 rounded-lg bg-navy-50 flex items-center justify-center">
                <Phone size={14} className="text-navy-600" />
              </div>
              <span className="text-xs">{COMPANY.phone}</span>
            </a>
            <Button
              onClick={() => scrollTo("#quote")}
              className="bg-hevi-red hover:bg-red-700 text-white font-semibold px-6 h-10 rounded-lg shadow-lg shadow-red-500/15 hover:shadow-red-500/25 transition-all duration-300 text-sm"
            >
              Get a Quote
              <ChevronRight size={14} className="ml-1" />
            </Button>
          </div>

          {/* Mobile toggle */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="lg:hidden p-2 text-slate-600 hover:text-navy-800 rounded-lg hover:bg-slate-50 transition-colors"
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="lg:hidden bg-white/98 backdrop-blur-xl border-t border-slate-100 shadow-xl">
          <div className="px-4 py-5 space-y-1">
            {NAV_LINKS.map((link) => (
              <button
                key={link.label}
                onClick={() => scrollTo(link.href)}
                className="flex items-center justify-between w-full py-3 px-4 text-slate-600 hover:bg-navy-50/60 rounded-xl font-medium text-sm transition-colors"
              >
                {link.label}
                <ChevronRight size={14} className="text-slate-300" />
              </button>
            ))}
            <div className="pt-4 border-t border-slate-100">
              <Button
                onClick={() => scrollTo("#quote")}
                className="w-full bg-hevi-red hover:bg-red-700 text-white font-semibold h-12 rounded-xl shadow-lg text-sm"
              >
                Get Your Free Quote
              </Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};
